import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/components-pages/AboutSection/About.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/components-pages/Contact.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/components-pages/Hero/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/components-pages/Projects/Projects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/components-pages/Skills/Skills.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlobAnimation"] */ "/opt/build/repo/components/UI/BlobAnimation.tsx");
